import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
const options = [{
  name: 'MEGA PACK',
  emoji: '📚',
  description: 'Los 6 tomos completos + 3 bonos',
  oldPrice: '$49.990',
  price: '$19.990',
  link: 'https://fonocheck.librosdigitales.pro/cart/44768212975752:1',
  ctaText: 'SÍ, QUIERO EL MEGA PACK →',
  badge: null,
  includes: [
  // — TOMOS —
  '6 Tomos del Mega Pack completos, ~560 páginas (sistema clínico completo de intervención)', '3 niveles por tomo: 3-5, 6-8 y 9-12 años (material adaptado a cada edad)', 'Monitor de Evidencia Visual™ (para mostrar avances al paciente y la familia)',
  // — BONOS —
  'Bono 1 — Guion de Devolución para Padres™ (qué decir y cómo en cada devolución)', 'Bono 2 — Adaptaciones clínicas por perfil (ajustes para distintos casos)', 'Bono 3 — Monitor de Evidencia Visual imprimible (versión lista para usar en sesión)',
  // — ACCESO —
  'Acceso inmediato (recibís todo apenas confirmás el pago)', 'Formato PDF descargable e imprimible (lo usás en pantalla o en papel)']
}, {
  name: 'MEGA PACK + KIT CRISIS Y FOCO',
  emoji: '🚨',
  description: '6 tomos + 24 sesiones listas + 20 fichas crisis + 20 fichas foco',
  oldPrice: '$54.980',
  price: '$24.980',
  link: 'https://fonocheck.librosdigitales.pro/cart/44780566216840:1',
  ctaText: 'SÍ, QUIERO + KIT CRISIS Y FOCO →',
  badge: null,
  includes: [
  // — TOMOS —
  '6 Tomos del Mega Pack completos, ~560 páginas (sistema clínico completo de intervención)', '3 niveles por tomo: 3-5, 6-8 y 9-12 años (material adaptado a cada edad)', 'Monitor de Evidencia Visual™ (para mostrar avances al paciente y la familia)',
  // — BONOS —
  'Bono 1 — Guion de Devolución para Padres™ (qué decir y cómo en cada devolución)', 'Bono 2 — Adaptaciones clínicas por perfil (ajustes para distintos casos)', 'Bono 3 — Monitor de Evidencia Visual imprimible (versión lista para usar en sesión)',
  // — FICHAS Y SESIONES —
  '24 sesiones cronometradas listas para usar (entrás al consultorio con todo armado)', '20 fichas para cuando el niño llega con estado alterado (recursos para regular crisis)', '20 fichas para recuperar el foco en sesión (cuando el paciente se desconecta)',
  // — ACCESO —
  'Acceso inmediato (recibís todo apenas confirmás el pago)', 'Formato PDF descargable e imprimible (lo usás en pantalla o en papel)']
}, {
  name: 'COMBO COMPLETO',
  emoji: '🏆',
  description: '6 tomos + 24 sesiones TEA + 24 TDAH + 24 ansiedad + 20 fichas crisis + 20 fichas foco + Pack Registros',
  oldPrice: '$58.990',
  price: '$28.990',
  link: 'https://fonocheck.librosdigitales.pro/cart/44780568903816:1',
  ctaText: 'SÍ, QUIERO EL COMBO COMPLETO →',
  badge: '⭐ MÁS ELEGIDO',
  includes: [
  // — TOMOS —
  '6 Tomos del Mega Pack completos, ~560 páginas (sistema clínico completo de intervención)', '3 niveles por tomo: 3-5, 6-8 y 9-12 años (material adaptado a cada edad)', 'Monitor de Evidencia Visual™ (para mostrar avances al paciente y la familia)',
  // — BONOS —
  'Bono 1 — Guion de Devolución para Padres™ (qué decir y cómo en cada devolución)', 'Bono 2 — Adaptaciones clínicas por perfil (ajustes para distintos casos)', 'Bono 3 — Monitor de Evidencia Visual imprimible (versión lista para usar en sesión)',
  // — SESIONES POR PERFIL —
  '24 sesiones para TEA (intervención adaptada al espectro autista)', '24 sesiones para TDAH (planificación pensada para la atención sostenida)', '24 sesiones para ansiedad (estrategias para regular y contener)', '24 sesiones cronometradas listas para usar (estructura ya armada por sesión)',
  // — FICHAS DE CRISIS Y FOCO —
  '20 fichas para cuando el niño llega con estado alterado (recursos para regular crisis)', '20 fichas para recuperar el foco en sesión (cuando el paciente se desconecta)',
  // — REGISTROS —
  'Pack Extendido de Registros y Planillas: 50 modelos (te organiza la parte administrativa)',
  // — ACCESO —
  'Acceso inmediato (recibís todo apenas confirmás el pago)', 'Formato PDF descargable e imprimible (lo usás en pantalla o en papel)']
}];
export function PurchaseSection() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedOption = options[selectedIndex];
  return <section id="compra" className="py-10 md:py-20 bg-[#EDF2F7]" data-id="element-118">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        {/* Unified Pricing Selector */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-2xl shadow-2xl overflow-hidden border border-gray-800" data-id="element-120">
          <div id="selector-pack" className="p-4 md:p-10 scroll-mt-4" data-id="element-121">
            <div className="text-center mb-4 md:mb-8" data-id="element-122">
              <h2 className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2" data-id="element-123">
                Elegí tu <span className="text-[#C9A84C]" data-id="element-124">PACK:</span>
              </h2>
              <p className="hidden md:block text-gray-400" data-id="element-125">
                Todas las opciones incluyen los 3 bonos estratégicos
              </p>
            </div>

            <div className="space-y-2.5 md:space-y-4 mb-4 md:mb-8" data-id="element-126">
              {options.map((option, index) => {
              const isSelected = selectedIndex === index;
              return <div key={index} onClick={() => setSelectedIndex(index)} className={`relative flex items-center justify-between p-3 md:p-5 rounded-xl cursor-pointer transition-all duration-200 border-2 ${isSelected ? 'border-[#C9A84C] bg-gray-800/80 shadow-[0_0_15px_rgba(201,168,76,0.15)]' : 'border-gray-700 bg-gray-800/30 hover:border-gray-600 hover:bg-gray-800/50'}`} data-id="element-127">
                    <div className="flex items-center gap-4" data-id="element-128">
                      {/* Radio Circle */}
                      <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${isSelected ? 'border-[#C9A84C]' : 'border-gray-500'}`} data-id="element-129">
                        {isSelected && <div className="w-3 h-3 rounded-full bg-[#C9A84C]" data-id="element-130" />}
                      </div>

                      <div data-id="element-131">
                        <div className="flex items-center gap-2 mb-0.5" data-id="element-132">
                          <span className="text-xl" data-id="element-133">{option.emoji}</span>
                          <h3 className="text-white font-bold text-sm md:text-base" data-id="element-134">
                            {option.name}
                          </h3>
                          {option.badge && <span className="hidden sm:inline-block bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-135">
                              {option.badge}
                            </span>}
                        </div>
                        {option.badge && <span className="sm:hidden inline-block bg-blue-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider mb-1" data-id="element-136">
                            {option.badge}
                          </span>}
                        <p className="text-gray-400 text-xs md:text-sm" data-id="element-137">
                          {option.description}
                        </p>
                      </div>
                    </div>

                    <div className="text-right pl-4" data-id="element-138">
                      <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-139">
                        {option.oldPrice}
                      </p>
                      <p className="text-white font-bold text-lg md:text-2xl" data-id="element-140">
                        {option.price}
                      </p>
                    </div>
                  </div>;
            })}
            </div>

            {/* CTA Button */}
            <motion.a href={selectedOption.link} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.4)', '0 0 0 15px rgba(34, 197, 94, 0)']
          }} transition={{
            boxShadow: {
              repeat: Infinity,
              duration: 1.5
            }
          }} className="block w-full bg-[#22C55E] text-white py-3.5 md:py-5 rounded-xl font-bold text-base md:text-xl text-center shadow-lg hover:bg-[#16A34A] transition-colors mb-3 no-underline" data-id="element-141">
              {selectedOption.ctaText}
            </motion.a>

            {/* Mercado Pago — directly under CTA */}
            <p className="text-center text-gray-300 text-xs md:text-sm mb-2 px-2" data-id="element-142">
              A continuación te enviaremos a Mercado Pago para que puedas
              realizar tu compra de forma segura.
            </p>
            <div className="bg-white rounded-lg px-3 py-2 mb-8 md:mb-10 max-w-md mx-auto" data-id="element-143">
              <img src="https://cdn.magicpatterns.com/uploads/i3AuJHJ1MwASbmSnmNPw7E/imagen.png" alt="Mercado Pago — Pago seguro y confiable. Aceptamos Visa, Mastercard, American Express, Diners Club y Mercado Pago." loading="lazy" decoding="async" className="w-full h-auto object-contain" data-id="element-144" />
            </div>

            {/* Includes Section */}
            <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700/50" data-id="element-145">
              <h4 className="text-gray-400 font-bold text-sm tracking-widest uppercase mb-6" data-id="element-146">
                TU PACK INCLUYE:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6" data-id="element-147">
                {selectedOption.includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-148">
                    <CheckIcon className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" data-id="element-149" />
                    <span className="text-gray-300 text-sm" data-id="element-150">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Guarantee — moved to end of page */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl p-8 mt-16 text-center border border-gray-100 shadow-sm max-w-2xl mx-auto" data-id="element-151">
          <ShieldCheckIcon className="w-12 h-12 text-[#1B3A5C] mx-auto mb-4" data-id="element-152" />
          <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-153">
            GARANTÍA 7 DÍAS
          </h3>
          <p className="text-gray-600 mb-4" data-id="element-154">
            Probalo. Si no sentís más orden, claridad y seguridad clínica, te
            devolvemos el 100%.
          </p>
          <p className="font-bold text-[#1B3A5C]" data-id="element-155">El riesgo es nuestro.</p>
        </motion.div>
      </div>
    </section>;
}